export const NOWRAP = 'mantine-datatable-nowrap';
export const ELLIPSIS = 'mantine-datatable-ellipsis';
export const POINTER_CURSOR = 'mantine-datatable-pointer-cursor';
export const CONTEXT_MENU_CURSOR = 'mantine-datatable-context-menu-cursor';
export const TEXT_SELECTION_DISABLED = 'mantine-datatable-text-selection-disabled';
export const TEXT_ALIGN_LEFT = 'mantine-datatable-text-align-left';
export const TEXT_ALIGN_CENTER = 'mantine-datatable-text-align-center';
export const TEXT_ALIGN_RIGHT = 'mantine-datatable-text-align-right';
